import { FormattedMessage } from 'dibs-react-intl';

const mandateTextContinue = (
    <FormattedMessage
        id="achForm.mandateTextContinue"
        defaultMessage="By clicking Continue, I authorize Braintree, a service of PayPal, on behalf of 1stDibs (i) to verify my bank account information using bank information and consumer reports and (ii) to debit my bank account."
    />
);

export default mandateTextContinue;
